var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"text":"","color":"white","retain-focus-on-click":"","ripple":false},on:{"click":function($event){return _vm.playAudio()}}},[_c('BaseSpriteIcon',{attrs:{"icon-name":"ico-sound"}}),_vm._v(" "),_c('span',{staticClass:"context-menu-text-item"},[_vm._v(_vm._s(_vm.$t('Context.short.play')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }